import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Rating extends Component {
  _generateStars = () => {
    const { rate, on, style } = this.props;
    const unrate = on - rate;

    let stars = [];

    if (rate > 0) {
      for (let i = 1; i <= rate; i++) {
        stars.push(
          <FontAwesomeIcon
            key={i}
            icon={["fas", "star"]}
            fill={style?.color || "goldenrod"}
            size={16}
          />
        );
      }
    }

    if (unrate > 0) {
      for (let i = 1; i <= unrate; i++) {
        stars.push(
          <FontAwesomeIcon
            key={i + 10}
            icon={["fas", "star"]}
            size={16}
            fill="white"
          />
        );
      }
    }

    if (rate > 0) return stars;
  };

  render() {
    return (
      this.props && (
        <div style={this.props?.style}>
          {this._generateStars()?.map((i) => i)}
        </div>
      )
    );
  }
}

export default Rating;
